import { h } from 'preact'
import { proxymedia } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileAccessoire = ({ tag, image, title, description, prefix_price, price, URL, analytics }) => {
   return (
      <div class="tuile-accessoire">
         <a
            href={URL}
            {...attributesAnalytics(analytics)}
         >
            {tag && (
               <div class="tag">
                  <div class="ob1-tag ob1-tag-primary">{tag}</div>
               </div>
            )}

            <div class="content-top">
               <img class="image" src={`${proxymedia(image, 'saveas=webp')}`} alt="" loading="lazy" />
            </div>

            <div className="content-bottom">
               <h3 class="model-parent h4">
                  <span className="brand">{title}</span>
                  <span className="model">{description}</span>
               </h3>

               {price && (
                  <div className="price ob1-price text-right" data-ob1-component="Price">
                     <p aria-hidden="true">
                        {prefix_price && <span className="ob1-price-from">{prefix_price}</span>}

                        <span className="ob1-price-amount">{price}&nbsp;€</span>
                     </p>
                  </div>)
               }
            </div>
         </a>
      </div>
   )
}
